import AsyncStorage from '@react-native-async-storage/async-storage';
import logger from './logger';

export async function storeAppData(key, value) {
   try {
      const result = await AsyncStorage.setItem(key, value);
      return result;
   } catch (error) {
      // Error saving data
   }
}

export async function retrieveAppData(key) {
   try {
      const value = await AsyncStorage.getItem(key);
      if (value !== null) {
         return value;
      } else {
         return '';
      }
   } catch (error) {
      logger('ERROR:: ' + error);
      return null;
      // Error retrieving data
   }
}
export async function removeSaveItem(key) {
   try {
      const value = await AsyncStorage.removeItem(key);
      if (value !== null) {
         return value;
      } else {
         return '';
      }
   } catch (error) {
      logger('ERROR:: ' + error);
      return null;
      // Error retrieving data
   }
}
